import {IDirective, IDirectiveFactory, IPromise, ITimeoutService} from 'angular';
import IRootScopeService = angular.IRootScopeService;

export class DVLoading implements IDirective {
    restrict = 'A';
    controller = DVLoadingController;
    controllerAs = 'vm';

    link = (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: DVLoadingController) => {
        let promise: IPromise<any>;
        scope.$watch(() => {
            return controller.isLoading;
        }, (newValue, oldValue) => {
            if ((newValue !== oldValue)) {
                if (newValue) {
                    controller.$timeout.cancel(promise);
                    element.show();
                } else {
                    promise = controller.$timeout(() => {
                        element.hide();
                    }, 500);
                }
            }
        });
    };

    static factory(): IDirectiveFactory {
        const directive = () => new DVLoading();
        directive.$inject = [];
        return directive;
    }
}

/**
 * Direktive  die ein Element ein oder ausblendet jenachdem ob ein http request pending ist
 */
export class DVLoadingController {

    static $inject: string[] = ['$timeout', '$rootScope'];

    isLoading: boolean;

    /* @ngInject */
    constructor(public $timeout: ITimeoutService, private $rootScope: IRootScopeService) {
        $rootScope.$on('$viewContentLoading',
            (event, toState, toParams, fromState, fromParams, options) => {
                this.isLoading = true;
            });
        $rootScope.$on('$viewContentLoaded', (event, toState, toParams, fromState, fromParams) => {
            this.isLoading = false;
        });
        $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
            this.isLoading = false;
        });
        $rootScope.$on('$stateChangeError', (event, toState, toParams, fromState, fromParams) => {
            this.isLoading = false;
        });
        $rootScope.$on('$stateNotFound', (event, toState, toParams, fromState, fromParams) => {
            this.isLoading = false;
        });

    }

}



// WEBPACK FOOTER //
// ./src/app/core/directive/dv-loading/dv-loading.ts